import {
  LOAD_AUTO_DISBURSEMENT,
  LOAD_BUSINESS,
  LOAD_WALLET,
  LOAD_BANK_ACCOUNTS,
  LOAD_STATS,
  LOAD_USER,
  LOAD_LENDER_PROFILE,
} from "../reducers/account";
import AxiosClient from "../utils/AxiosClient";

export const fetchBusiness = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get("business");
console.log(response.data.data,'jjjkkklll')
    dispatch({ type: LOAD_BUSINESS, data: response.data.data || {} });
  } catch (error) {
    dispatch({ type: LOAD_BUSINESS, data: {} });
  }
};

export const fillUser = (data) => {
  return { type: LOAD_USER, data };
};

export const updateUser = async ({ photo_url }) => {
  const client = await AxiosClient();
  return (await client.put("settings/profile", { photo_url }))?.data;
};

export const fetchWallet = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get("wallet");
    dispatch({ type: LOAD_WALLET, data: response.data.data || {} });
  } catch (error) {
    dispatch({ type: LOAD_WALLET, data: {} });
  }
};

export const fetchStats = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get("business/stats");
    dispatch({ type: LOAD_STATS, data: response.data.data || {} });
  } catch (error) {
    dispatch({ type: LOAD_STATS, data: {} });
  }
};

export const fetchTransactions = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/transactions?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=reference,description`
    )
  )?.data;
};

export const fetchValidations = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/validations?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=uuid`
    )
  )?.data;
};

export const fetchAgents = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/agents?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=first_name,last_name,email,phone_number`
    )
  )?.data;
};

export const fetchUsers = async (
  page = 1,
  search = "",
  sortBy = "created_on",
  sortDir = "DESC",
  limit = 10
) => {
  const client = await AxiosClient();
  return (
    await client.get(
      `business/users?page=${page}&limit=${limit}&sort_by=${sortBy}&sort_dir=${sortDir}&search=${search}&search_fields=first_name,last_name,email,phone_number`
    )
  )?.data;
};

export const updateAgent = async ({ id, ...data }) => {
  const client = await AxiosClient();
  return (await client.put(`business/agents/${id}`, data))?.data;
};

export const fetchAgent = async (id) => {
  const client = await AxiosClient();
  return (await client.get(`business/agents/${id}`))?.data;
};

export const fetchAgentStats = async (user_id) => {
  const client = await AxiosClient();
  return (await client.get(`business/stats?lender_user_id=${user_id}`))?.data;
};

export const createAgent = async ({
  phone_number,
  email,
  minimium_credit_score,
  min_tenor_type,
  min_tenor_value,
  max_tenor_type,
  max_tenor_value,
  min_amount,
  max_amount,
  max_loan_amount,
  display_name,
  is_private = true,
  max_loan_count,
  locations,
  borrower_category,
}) => {
  const client = await AxiosClient();
  return (
    await client.post("business/agents", {
      phone_number,
      email,
      lender_profile: {
        minimium_credit_score,
        min_tenor_type,
        min_tenor_value,
        max_tenor_type,
        max_tenor_value,
        min_amount,
        max_amount,
        max_loan_amount,
        display_name,
        is_private,
        max_loan_count,
        locations,
        borrower_category,
      },
    })
  )?.data;
};

export const createUser = async ({
  phone_number,
  email,
  first_name,
  last_name,
}) => {
  const client = await AxiosClient();
  return (
    await client.post("business/users", {
      phone_number,
      email,
      first_name,
      last_name,
    })
  )?.data;
};

export const fetchBankAccounts = async () => {
  const client = await AxiosClient();
  return (await client.get("settings/banks"))?.data;
};

export const updateBusiness = async ({
  bvn,
  registration_number,
  registration_date,
  account_number,
  bank_code,
  pin,
  otp,
}) => {
  const client = await AxiosClient();
  return (
    await client.patch("business", {
      bvn,
      registration_number,
      registration_date,
      account_number,
      bank_code,
      pin,
      otp,
    })
  )?.data;
};

export const fetchAutoDisbursement = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get("business/settings");
    dispatch({ type: LOAD_AUTO_DISBURSEMENT, data: response.data.data || {} });
  } catch (error) {
    dispatch({ type: LOAD_AUTO_DISBURSEMENT, data: {} });
  }
};

export const updateAutoDisbursement = async ({
  enabled,
  customer_only,
  min_repaid_loans,
  max_amount,
}) => {
  const client = await AxiosClient();
  return (
    await client.patch("business/settings", {
      enabled,
      customer_only,
      min_repaid_loans,
      max_amount,
    })
  )?.data;
};

export const withdrawFromWallet = async ({ pin, amount, bank_id }) => {
  const client = await AxiosClient();
  return (await client.post("wallet/withdraw", { pin, amount, bank_id }))?.data;
};

export const fetchLenderProfile = () => async (dispatch) => {
  try {
    const client = await AxiosClient();
    const response = await client.get("settings/profile/lender");
    dispatch({ type: LOAD_LENDER_PROFILE, data: response.data.data || {} });
  } catch (error) {
    dispatch({ type: LOAD_AUTO_DISBURSEMENT, data: {} });
  }
};

export const updateLenderProfile = async (data) => {
  const client = await AxiosClient();
  return (await client.put("settings/profile/lender", { ...data }))?.data;
};

export const fetchInsuranceServices = async () => {
  const client = await AxiosClient();
  return (await client.get("insurance/services"))?.data;
};

export const updateInsuranceService = async (data) => {
  const client = await AxiosClient();
  return (await client.patch("business/add-service", { ...data }))?.data;
};
